import { FC } from "react";
import { X, UserCircle2 } from "lucide-react";
import { useAvatar } from "src/hooks";

interface Props {
	target: AdminImpersonationTarget;
	onRemove: () => void;
	isRemoving?: boolean;
}

const ImpersonationTargetCard: FC<Props> = ({
	target,
	onRemove,
	isRemoving
}) => {
	const fullName = `${target.first_name} ${target.last_name}`.trim();
	const { data: avatarSrc, isError: isAvatarError } = useAvatar({
		userId: target.user_id
	});

	return (
		<div className="flex items-center gap-4 rounded-lg border border-border bg-white p-3">
			<div className="flex-shrink-0">
				{!isAvatarError && avatarSrc ? (
					<img
						src={avatarSrc}
						alt=""
						className="h-10 w-10 rounded-full object-cover"
					/>
				) : (
					<UserCircle2 className="h-10 w-10 text-zinc-500" aria-hidden="true" />
				)}
			</div>
			<div className="flex-1 min-w-0">
				<p className="text-sm font-medium text-foreground truncate">
					{fullName}
				</p>
				{target.job_title && (
					<p className="text-xs text-muted-foreground truncate">
						{target.job_title}
					</p>
				)}
				{target.email && (
					<p className="text-xs text-muted-foreground truncate">
						{target.email}
					</p>
				)}
			</div>
			<button
				type="button"
				onClick={onRemove}
				disabled={isRemoving}
				className="text-zinc-600 hover:text-red-600 disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:rounded"
				aria-label={`Remove ${fullName} from impersonation targets`}
			>
				<X className="h-4 w-4" aria-hidden="true" />
			</button>
		</div>
	);
};

export default ImpersonationTargetCard;
